import { v4 as uuidv4 } from 'uuid';
import i18n from '../../../i18n';
import { CategoricalGroupView } from './CategoricalGroupView';

const t = (value: string) => i18n.t('sidePanel.' + value)

export const CategoricalGroupTab = (): ITab => {
    return {
        id: uuidv4(),
        title: t('directory.submenu.categoricalGroup'),
        plugin: 'categorical_group_plugin',
        view: {
            content: <CategoricalGroupView/>
        }
    }
}